import { render } from "./Page1.vue?vue&type=template&id=4274bd2a&scoped=true"
import script from "./Page1.vue?vue&type=script&lang=js"
export * from "./Page1.vue?vue&type=script&lang=js"

import "./Page1.vue?vue&type=style&index=0&id=4274bd2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4274bd2a"]])

export default __exports__